const popupShowKeys = ["popupPortalEl", "wrapperClassname", "className", "hasOverlay", "isInIframe", "closeFromOverlay", "beforeShowCallback", "beforeHideCallback", "afterHideCallback", "afterShowCallback"];
export const getPopupShowConfig = (config, legacyCallback) => {
    let popupShowConfig = {};
    popupShowConfig.legacyCallback = legacyCallback;
    popupShowConfig.hasCloseBtn = (config.crossBtn === false) ? false : true;
    config.offsetTop !== undefined && (popupShowConfig.offsetTop = config.offsetTop);
    popupShowKeys.forEach((key) => {
        config[key] !== undefined && (popupShowConfig[key] = config[key]);
    });
    return popupShowConfig;
};
//# sourceMappingURL=getPopupShowConfig.js.map